import { fromEvent, Observable } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';

import { WindowDimensions, ViewportService } from './viewport.service';

const scope = window;
const Events = {
  RESIZE: 'resize',
};
const Viewport = new ViewportService();

class ResizeService {
  private cache: WindowDimensions | undefined;

  constructor() {
    this.resizeEvent = this.registerResizeEventStream();
    this.getCurrent = this.tryCachedReturn;
  }

  private cacheSize(data: WindowDimensions): WindowDimensions {
    this.cache = data;
    return this.cache;
  }

  private didChange(data: WindowDimensions): boolean {
    return data !== this.cache;
  }

  private tryCachedReturn(): WindowDimensions {
    return this.cache ? this.cache : Viewport.getSize();
  }

  private registerResizeEventStream(): Observable<WindowDimensions> {
    return fromEvent(scope, Events.RESIZE).pipe(
      startWith(Viewport.getSize()),
      map(() => Viewport.getSize()),
      filter((dimensions) => this.didChange(dimensions)),
      map((dimensions) => this.cacheSize(dimensions))
    );
  }

  public resizeEvent: Observable<WindowDimensions>;
  public getCurrent: () => WindowDimensions;
}

export default new ResizeService();
